import { Injectable } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { ControleCientePage } from "../../app/components-modal/controleciente/controleciente.page";
import { ControleCienteProvider } from "./controleciente";

@Injectable({
  providedIn: 'root'
})
export class ControleService {
  public controleCienteResponse: Array<any> = null;
  public isOpenModal = false;

  constructor(
    private controleCienteProvider: ControleCienteProvider,
    private modalController: ModalController
  ) { }

  async openModalControle(forceRefresh = false){
    if(this.isOpenModal)
      return;
    
    if(forceRefresh || this.controleCienteResponse == null)
    {
      await this.get(forceRefresh);
    }

    if(this.controleCienteResponse == null || (Array.isArray(this.controleCienteResponse) && this.controleCienteResponse.length == 0))
    {
      return;
    }

    const modal = await this.modalController.create({
      component: ControleCientePage,
      componentProps: {
        controleCienteResponse: this.controleCienteResponse,
      },
      cssClass: 'smallModal',
      backdropDismiss: false
    });
  

    modal.onDidDismiss()
      .then((ret) => {
        if(ret.data?.completed)
        {
          this.controleCienteResponse = [];
        }
      }).finally(() => {
        this.isOpenModal = false;
      })

    return await modal.present().finally(() => {
      this.isOpenModal = true;
    });
  }

  async updateControle(tipo: string, codigo: string, lido: boolean)
  {
    const {Item: response} = await this.controleCienteProvider.updateStatusControle(tipo, codigo, lido);

    if(response.status_ret == "NOK")
    {
      console.error(response);
      return false;
    }

    return true;
  }
  async get(forceRefresh = false)
  {
    // TODO: Andre - CONTROLE CIENCIA - DES MODAL - verificar se o controle ciência vem daqui - voltar depois
    return;
    if(forceRefresh == false && this.controleCienteResponse != null)
    {
      return this.controleCienteResponse;
    }

    const {Item: response} = await this.controleCienteProvider.get();

    if(response.status_ret == "NOK")
    {
      console.error(response);
      this.controleCienteResponse = []
      return this.controleCienteResponse;
    }

    if(!Array.isArray(response.data?.retorno))
    {
      this.controleCienteResponse = []
      return this.controleCienteResponse;
    }

    function getIcon(tipo: string){
      switch (tipo)
      {
        case "5": // Boletos
          return "card-outline";
        case "6": // Autorização
          return "id-card-outline";
        case "7": // Informe
          return "bar-chart-outline";
        default:
          return "chatbox-outline";
      }
    }

    if(Array.isArray(response.data?.retorno))
    {
      if(response.data.retorno.length == 0)
      {
        this.controleCienteResponse = []
        return [];
      }

      this.controleCienteResponse = response.data?.retorno.map(controle => {
        controle['icon'] = getIcon(controle.tipo)
        return controle
      });

      return this.controleCienteResponse;
    }

    this.controleCienteResponse = [];
    return [];
  }
}
